import { useCallback } from 'react'

import { driverDashboardManager } from '../Stores/DriverDashboardManager'

/**
 * Public API: keeps the driver's assignment list in sync with realtime events.
 *
 * A "Транспорт розподілено" action publishes UserNotification.Created over
 * Centrifugo. Besides updating the notification badge, the dashboard list must
 * refresh too — otherwise a brand-new assignment is missing from Головна until
 * the driver re-enters the page, causing a mismatch with the latest notification.
 *
 * Refresh is best-effort and runs in the background (SWR keeps the current list
 * visible), so it is safe to fire even when the dashboard page is not mounted.
 */
export const useDriverAssignmentsRealtime = () => {
    const onUserNotificationCreated = useCallback(() => {
        if (!navigator.onLine) return
        driverDashboardManager.fetchAssignments().catch(() => {})
    }, [])

    return { onUserNotificationCreated }
}
